import React, { useEffect, useState } from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid,
  PieChart, Pie, Cell, LineChart, Line, Legend,
} from "recharts";
import "../styles/AdminDashboard.css";

const AdminDashboard = () => {
  const [violations, setViolations] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchViolations = async () => {
    try {
      const res = await fetch("http://localhost:5000/api/violations");
      const data = await res.json();
      if (data.success) setViolations(data.data.reverse()); // latest first
      setLoading(false);
    } catch (err) {
      console.error("Error fetching violations:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchViolations();
    const interval = setInterval(fetchViolations, 5000); // refresh every 5s
    return () => clearInterval(interval);
  }, []);

  // --- Data processing ---
  const countByEmail = () => {
    const counts = {};
    violations.forEach((v) => {
      const email = v.email || "Unknown";
      counts[email] = (counts[email] || 0) + 1;
    });
    return Object.entries(counts).map(([email, count]) => ({ email, count }));
  };

  const countByTime = () => {
    const timeline = {};
    violations.forEach((v) => {
      const t = v.timestamp ? v.timestamp.split(" ")[1].slice(0, 5) : "Unknown";
      timeline[t] = (timeline[t] || 0) + 1;
    });
    return Object.entries(timeline).map(([time, count]) => ({ time, count }));
  };

  const COLORS = ["#ff4d4f", "#1677ff", "#52c41a", "#faad14", "#722ed1"];

  return (
    <div className="admindashboard-container">
      <h2>🔴 Live Monitoring Dashboard</h2>

      {loading ? (
        <p>Loading violations...</p>
      ) : violations.length === 0 ? (
        <p className="admindashboard-no-data">No violations yet 🎉</p>
      ) : (
        <>
          {/* === STATISTICS OVERVIEW === */}
          <div className="admindashboard-charts-grid">

            {/* Line chart over time */}
            <div className="admindashboard-chart-card">
              <h3>Violations Over Time</h3>
              <LineChart width={350} height={250} data={countByTime()}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="count" stroke="#1677ff" />
              </LineChart>
            </div>

            {/* Pie chart by student */}
            <div className="admindashboard-chart-card">
              <h3>Violations by Student</h3>
              <PieChart width={350} height={250}>
                <Pie
                  data={countByEmail()}
                  dataKey="count"
                  nameKey="email"
                  outerRadius={100}
                  label
                >
                  {countByEmail().map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </div>

            {/* Bar chart by student */}
            <div className="admindashboard-chart-card">
              <h3>Violations Count (Students)</h3>
              <BarChart width={350} height={250} data={countByEmail()}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="email" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="count" fill="#ff4d4f" />
              </BarChart>
            </div>
          </div>

          {/* === TABLE SECTION === */}
          <h3>Recent Violations</h3>
          <table className="admindashboard-violations-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Student Email</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {violations.map((v, i) => (
                <tr key={i}>
                  <td>{v.timestamp || "N/A"}</td>
                  <td>{v.email || "Unknown"}</td>
                  <td>{v.details || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default AdminDashboard;
